import {
	asyncActionError,
	asyncActionFinish,
	asyncActionStart
} from '../../app/async/asyncActions';
import {
	FETCH_BRAND_STATS,
	FETCH_LOCATION_STATS,
	FETCH_CLIENTS_STATS,
	FETCH_STOCK_TYPE_STATS
} from './dashboardConstants';

// GET STATUS STATS //////////////////////////////////////////////////////////////
export const getStatusStats = () => {
	return async (dispatch, getState) => {
		const state = getState();

		const companyKegs = (await state.firestore.ordered.companyKegs)
			? state.firestore.ordered.companyKegs?.filter((k) => !k.isArchive)
			: [];

		const partnerKegs = (await state.firestore.ordered.partnerKegs)
			? state.firestore.ordered.partnerKegs?.filter((k) => !k.isArchive)
			: [];

		try {
			dispatch(asyncActionStart());
			const kegsNewArray = companyKegs?.filter(
				(keg) => keg.kegStatus === 'new'
			);
			const kegsEmptyArray = companyKegs?.filter(
				(keg) => keg.kegStatus === 'empty'
			);
			const kegsWarehouseArray = companyKegs?.filter(
				(keg) => keg.kegStatus === 'warehouse'
			);
			const kegsDispatchedArray = companyKegs?.filter(
				(keg) => keg.kegStatus === 'dispatched'
			);
			const kegsIssueArray = companyKegs?.filter(
				(keg) => keg.kegStatus === 'issue'
			);
			const statusStats = {
				all: 0,
				new: 0,
				empty: 0,
				warehouse: 0,
				dispatched: 0,
				issue: 0,
				partner: 0
			};
			statusStats.all = companyKegs?.length;
			statusStats.new = kegsNewArray.length;
			statusStats.empty = kegsEmptyArray.length;
			statusStats.warehouse = kegsWarehouseArray.length;
			statusStats.dispatched = kegsDispatchedArray.length;
			statusStats.issue = kegsIssueArray.length;
			statusStats.partner = partnerKegs?.length;

			dispatch({ type: 'FETCH_STATUS_STATS', payload: { statusStats } });
			dispatch(asyncActionFinish());
		} catch (error) {
			console.log(error);
			dispatch(asyncActionError());
		}
	};
};

// GET COMPANY STATS //////////////////////////////////////////////////////////
export const getCompanyOverviewStats = () => {
	return async (dispatch, getState, { getFirestore }) => {
		const state = getState();

		try {
			dispatch(asyncActionStart());

			// LOCATIONS
			let locations = await state.firestore.ordered.locations;

			// BRANDS
			let brands = await state.firestore.ordered.brands;

			// CLIENTS
			let clients = await state.firestore.ordered.clients;

			//PARTNERS
			let partners = await state.firestore.ordered.partners;

			// STATS OBJECT
			const overviewStats = {};
			overviewStats.locations = locations.length;
			overviewStats.locationsIds = locations.map((l) => l.id);
			overviewStats.brands = brands.length;
			overviewStats.brandsIds = brands.map((b) => b.id);
			overviewStats.clients = clients.length;
			overviewStats.clientsIds = clients.map((c) => c.id);
			overviewStats.partners = partners.length;
			overviewStats.partnersIds = partners.map((p) => p.id);

			dispatch({
				type: 'FETCH_COMPANY_OVERVIEW',
				payload: { overviewStats }
			});
			dispatch(asyncActionFinish());
		} catch (error) {
			console.log(error);
			dispatch(asyncActionError());
		}
	};
};

export const getPartnerLocationStats = () => {
	return async (dispatch, getState) => {
		const state = getState();
		try {
			dispatch(asyncActionStart());

			// KEGS
			const partnerKegs = (await state.firestore.ordered.partnerKegs)
				? state.firestore.ordered.partnerKegs?.filter((k) => !k.isArchive)
				: [];
			// Kegs with Locations
			const partnerKegsInWarehouse = partnerKegs?.filter(
				(keg) => keg.locationStatus === 'in_warehouse__partner'
			);
			// Kegs with Locations & Empty
			const emptyKegs = partnerKegsInWarehouse.filter((keg) => !keg.isFilled);
			// Kegs with Locations & Filled
			const filledKegs = partnerKegsInWarehouse.filter((keg) => keg.isFilled);

			const locationIds = [];
			const locations = [];
			partnerKegsInWarehouse.forEach((k) => {
				if (!locationIds.includes(k.locationObj.id)) {
					locationIds.push(k.locationObj.id);
					locations.push(k.locationObj);
				}
			});

			let locationStockStats = [];
			locations.forEach((location) => {
				const thisLocationsKegs = partnerKegsInWarehouse.filter(
					(keg) => keg.locationObj.id === location.id
				);
				const thisEmptyKegs = thisLocationsKegs.filter((keg) => !keg.isFilled);
				const thisFilledKegs = thisLocationsKegs.filter((keg) => keg.isFilled);

				const locationData = {
					name: location.name,
					countEmpty: thisEmptyKegs.length,
					empty: thisEmptyKegs.map((k) => k.id),
					countFilled: thisFilledKegs.length,
					filled: thisFilledKegs.map((k) => k.id),
					countInWarehouse: thisLocationsKegs.length,
					id: location.id
				};
				locationStockStats = [...locationStockStats, locationData];
			});
			locationStockStats.sort((a, b) => (a.name > b.name ? 1 : -1));

			// STATS OBJECT
			const locationsStats = {};
			locationsStats.countInWarehouse = partnerKegsInWarehouse.length;
			locationsStats.countEmpty = emptyKegs.length;
			locationsStats.countFilled = filledKegs.length;
			locationsStats.locationTotals = locationStockStats;
			dispatch({
				type: 'FETCH_PARTNER_LOCATION_STATS',
				payload: { locationsStats }
			});

			dispatch(asyncActionFinish());
		} catch (error) {
			console.log(error);
			dispatch(asyncActionError());
		}
	};
};

export const getAtPartnerLocationStats = () => {
	return async (dispatch, getState) => {
		const state = getState();
		try {
			dispatch(asyncActionStart());
			const kegs = (await state.firestore.ordered.companyKegs)
				? state.firestore.ordered.companyKegs?.filter((k) => !k.isArchive)
				: [];

			const atPartnerKegs = kegs.filter((keg) => keg.partnerLink);

			const atPartnerKegsInWarehouse = atPartnerKegs?.filter(
				(keg) => keg.locationStatus === 'in_warehouse__partner'
			);

			const inTransitKegs = atPartnerKegs?.filter(
				(keg) => keg.locationStatus === 'dispatched__partner'
			);

			const allAtPartnerKegs = [...atPartnerKegsInWarehouse, ...inTransitKegs];

			const emptyKegs = allAtPartnerKegs?.filter((keg) => !keg.isFilled);
			const filledKegs = allAtPartnerKegs?.filter((keg) => keg.isFilled);

			const locationIds = [];
			const locations = [];
			atPartnerKegsInWarehouse.forEach((k) => {
				if (!locationIds.includes(k.locationObj.id)) {
					locationIds.push(k.locationObj.id);
					locations.push(k.locationObj);
				}
			});

			const inTransitPartnerIds = [];
			const inTransitPartners = [];

			inTransitKegs.forEach((k) => {
				if (!inTransitPartnerIds.includes(k.partnerObj.id)) {
					inTransitPartnerIds.push(k.partnerObj.id);
					inTransitPartners.push(k.partnerObj);
				}
			});

			let locationStockStats = [];
			locations.forEach((location) => {
				const thisLocationsKegs = atPartnerKegsInWarehouse.filter(
					(keg) => keg.locationObj.id === location.id
				);
				const thisEmptyKegs = thisLocationsKegs.filter((keg) => !keg.isFilled);
				const thisFilledKegs = thisLocationsKegs.filter((keg) => keg.isFilled);

				const locationData = {
					name: location.name,
					partner: thisLocationsKegs[0].partnerObj.name,
					id: location.id,
					countEmpty: thisEmptyKegs.length,
					empty: thisEmptyKegs.map((k) => k.id),
					countFilled: thisFilledKegs.length,
					filled: thisFilledKegs.map((k) => k.id),
					countInWarehouse: thisLocationsKegs.length
				};
				locationStockStats = [...locationStockStats, locationData];
			});

			inTransitPartners.forEach((p) => {
				const thisLocationsKegs = inTransitKegs.filter(
					(k) => k.partnerObj.id === p.id
				);

				const thisEmptyKegs = thisLocationsKegs.filter((keg) => !keg.isFilled);

				const thisFilledKegs = thisLocationsKegs.filter((keg) => keg.isFilled);

				const locationData = {
					name: 'In Transit',
					partner: p.name,
					id: p.id,
					countEmpty: thisEmptyKegs.length,
					empty: thisEmptyKegs.map((k) => k.id),
					countFilled: thisFilledKegs.length,
					filled: thisFilledKegs.map((k) => k.id),
					countInWarehouse: thisLocationsKegs.length
				};
				locationStockStats = [...locationStockStats, locationData];
			});

			locationStockStats.sort((a, b) => (a.name > b.name ? 1 : -1));

			// STATS OBJECT
			const locationsStats = {};
			locationsStats.countInWarehouse = allAtPartnerKegs?.length;
			locationsStats.countEmpty = emptyKegs.length;
			locationsStats.countFilled = filledKegs.length;
			locationsStats.locationTotals = locationStockStats;
			dispatch({
				type: 'FETCH_AT_PARTNER_LOCATION_STATS',
				payload: { locationsStats }
			});

			dispatch(asyncActionFinish());
		} catch (error) {
			console.log(error);
			dispatch(asyncActionError());
		}
	};
};

// GET CLIENTS STATS //////////////////////////////////////////////////////////
export const getClientsStats = () => {
	return async (dispatch, getState, { getFirestore }) => {
		const state = getState();

		try {
			dispatch(asyncActionStart());

			// KEGS
			const kegs = (await state.firestore.ordered.companyKegs)
				? state.firestore.ordered.companyKegs?.filter((k) => !k.isArchive)
				: [];
			// Stock with Clients
			const stockWithClients = kegs.filter(
				(item) => item.clientLink && item && item.kegStatus === 'dispatched'
			);
			// CLIENTS
			const clients = await state.firestore.ordered.clients;

			let clientsStockStats = [];
			clients.forEach((client) => {
				// Stock Type = Fridge
				const stockTypeKeg = stockWithClients.filter(
					(item) => item.clientObj.id === client.id && item.type === 'keg'
				);
				const stockTypeGas = stockWithClients.filter(
					(item) => item.clientObj.id === client.id && item.type === 'gas'
				);
				const stockTypeFridges = stockWithClients.filter(
					(item) => item.clientObj.id === client.id && item.type === 'fridge'
				);
				const allClientStock = stockWithClients.filter(
					(item) => item.clientObj.id === client.id
				);
				// Profile Completed Score
				let score = 0;
				if (client.name) {
					score = score + 5;
				}
				if (client.email) {
					score = score + 5;
				}
				if (client.phone) {
					score = score + 5;
				}
				if (client.website) {
					score = score + 5;
				}
				if (client.address_line1) {
					score = score + 10;
				}
				if (client.address_line2) {
					score = score + 5;
				}
				if (client.address_suburb) {
					score = score + 10;
				}
				if (client.address_city) {
					score = score + 10;
				}
				if (client.address_province) {
					score = score + 10;
				}
				if (client.address_postalCode) {
					score = score + 5;
				}
				if (client.gps_lat) {
					score = score + 1;
				}
				if (client.gps_lng) {
					score = score + 1;
				}
				if (client.contact_person_name) {
					score = score + 10;
				}
				if (client.contact_person_position) {
					score = score + 2;
				}
				if (client.contact_person_email) {
					score = score + 1;
				}
				if (client.contact_person_phone) {
					score = score + 10;
				}
				if (client.contact_person_mobile) {
					score = score + 5;
				}

				// Build Client Object to return
				const clientData = {
					id: client.id,
					name: client.name,
					countAllStock: allClientStock.length,
					countKegs: stockTypeKeg.length,
					kegs: stockTypeKeg,
					countGas: stockTypeGas.length,
					gas: stockTypeGas,
					countFridges: stockTypeFridges.length,
					fridges: stockTypeFridges,
					score
				};
				// Build data object
				clientsStockStats = [...clientsStockStats, clientData];
			});
			clientsStockStats.sort((a, b) => (a.name > b.name ? 1 : -1));

			dispatch({
				type: FETCH_CLIENTS_STATS,
				payload: { clientsStockStats }
			});

			dispatch(asyncActionFinish());
		} catch (error) {
			console.log(error);
			dispatch(asyncActionError());
		}
	};
};

// GET STOCK STATS ////////////////////////////////////////////////////////////
export const getStockStats = (companyId) => {
	return async (dispatch, getState, { getFirestore }) => {
		const state = getState();

		try {
			dispatch(asyncActionStart());
			const kegs = (await state.firestore.ordered.companyKegs)
				? state.firestore.ordered.companyKegs?.filter((k) => !k.isArchive)
				: [];

			const stockTypeAllArray = kegs.filter(
				(k) => k.type === 'keg' || k.type === 'fridge' || k.type === 'gas'
			);
			const stockTypeKegsArray = kegs.filter((k) => k.type === 'keg');
			const stockTypeFridgeArray = kegs.filter((k) => k.type === 'fridge');
			const stockTypeGasArray = kegs.filter((k) => k.type === 'gas');

			const stockStats = {
				all: 0,
				kegs: 0,
				fridge: 0,
				gas: 0
			};
			stockStats.all = stockTypeAllArray.length;
			stockStats.kegs = stockTypeKegsArray.length;
			stockStats.fridge = stockTypeFridgeArray.length;
			stockStats.gas = stockTypeGasArray.length;

			dispatch({ type: FETCH_STOCK_TYPE_STATS, payload: { stockStats } });
			dispatch(asyncActionFinish());
		} catch (error) {
			console.log(error);
			dispatch(asyncActionError());
		}
	};
};
